import React from 'react';
import Layout from '@/common/Layout';
import DispensingPage from './components/DispensingPage';

const Dispensing = () => {
  return (
    <>
      <Layout sider={false}>
        <DispensingPage />
      </Layout>
    </>
  );
};

export default Dispensing;
